












import Vue from 'vue'
import { language_t } from '@/store/modules/pref'
export default Vue.extend({
  computed: {
    curLang (): language_t { return this.$s.$state.pref.global.lang },
    curLangLabel (): string {
      if (this.curLang === 'auto') { return `${this.$t('sys.lang.auto') } (${this.$t('langName')})` }
      return this.$t('langName') + ''
    }
  }
})
